import React from "react";
import styled from "styled-components/macro";
import RideUnitFrontPlan from "./RideUnitFrontPlan";
import RideUnitTopPlan from "./RideUnitTopPlan";
import SidePlan from "./SidePlan";
import Footer from "../../MyTulu/PDF/Footer";
import { device } from "../../device";
import largeBicycleStand from "../../../images/ride/pdf/large bicycle stand.svg";
import smallBicycleStand from "../../../images/ride/pdf/small bicycle stand.svg";
import smallScooterStand from "../../../images/ride/pdf/small scooter stand.svg";
import largeScooterStand from "../../../images/ride/pdf/large scooter stand.svg";

const RidePlans = ({
  rideItems,
  location,
  type,
  isPDF,
  buildingName,
  pageUp,
}) => {
  const currentDate = new Date()
    .toLocaleDateString()
    .replace(".", "-")
    .replace(".", "-");

  const standTypes = { large: 0, small: 0 };

  rideItems?.forEach((item) => {
    if (type === "scooter") {
      if (item.items.length > 3) {
        standTypes["large"]++;
      } else {
        standTypes["small"]++;
      }
    }
    if (type === "bicycle") {
      if (item.items.length > 2) {
        standTypes["large"]++;
      } else {
        standTypes["small"]++;
      }
    }
  });

  let unitWidth;
  let relavantImg;

  const isCM = location !== "us";
  return (
    <>
      {Object.keys(standTypes)
        .filter((standType) => standTypes[standType] > 0)
        .map((standType) => {
          let title;
          if (type === "scooter") {
            if (standType === "large") {
              title = "Large Scooter Stand";
              relavantImg = largeScooterStand;
              unitWidth = !isCM ? 74 : 188;
            }
            if (standType === "small") {
              title = "Small Scooter Stand";
              relavantImg = smallScooterStand;
              unitWidth = !isCM ? 56.5 : 144;
            }
          }
          if (type === "bicycle") {
            if (standType === "large") {
              title = "Large Bicycle Stand";
              relavantImg = largeBicycleStand;
              unitWidth = !isCM ? 79 : 200;
            }
            if (standType === "small") {
              title = "Small Bicycle Stand";
              relavantImg = smallBicycleStand;
              unitWidth = !isCM ? 54 : 137;
            }
          }
          const Wrap = ({ children, standType }) =>
            !isPDF ? (
              <Wrapper key={standType}> {children}</Wrapper>
            ) : (
              <PDFPage key={standType}>
                {isPDF && (
                  <Pager>
                    {" "}
                    {currentDate} {pageUp}
                  </Pager>
                )}
                {isPDF && <Footer />}
                <TextWrapper style={{ padding: isPDF && 0 }}>
                  {isPDF && (
                    <div
                      style={{
                        marginLeft: 97,
                        fontSize: 40,
                        fontFamily: "Lexend",
                        fontWeight: "bold",
                      }}
                    >
                      {buildingName} <br />
                    </div>
                  )}
                  <ParaOne
                    style={{
                      textAlign: isPDF && "left",
                      marginLeft: isPDF && 97,
                      fontSize: isPDF && 50,
                      marginBottom: isPDF && 68,
                    }}
                  >
                    ride plan{" "}
                  </ParaOne>
                </TextWrapper>
                <Wrapper>{children}</Wrapper>
              </PDFPage>
            );

          const pdfFontSize = { fontSize: isPDF && 25 };
          const sideDetailsPdfWidth = {
            width: isPDF && 298,
            marginRight: isPDF && 50,
          };
          const pdfLine = { width: isPDF && "100%" };
          return (
            <Wrap key={standType}>
              <SideDetails
                style={{
                  marginLeft: isPDF && 100,
                  ...sideDetailsPdfWidth,
                }}
              >
                <UpperLine style={pdfLine} />
                <Title style={pdfFontSize}>TULU Ride</Title>

                <Title style={pdfFontSize}>{title}</Title>
                <Flex>
                  {" "}
                  <Text style={pdfFontSize}>Quantity</Text>{" "}
                  <Spec style={pdfFontSize}>{standTypes[standType]}</Spec>{" "}
                </Flex>
                <Flex>
                  {" "}
                  <Text style={pdfFontSize}>Total width</Text>{" "}
                  <Spec style={pdfFontSize}>
                    {standTypes[standType] * unitWidth}
                    {!isCM ? `"` : `CM`}
                  </Spec>
                </Flex>
                <BottomLine style={pdfLine} />
              </SideDetails>

              <PlansWrapperAllViews>
                {isPDF ? (
                  <PDFRideImage
                    type={standType + " " + type}
                    src={relavantImg}
                  ></PDFRideImage>
                ) : (
                  <PlansWrapper>
                    <div>
                      <ViewTitle> Front View</ViewTitle>

                      <RideUnitFrontPlan
                        location={location}
                        size={standType}
                        type={type}
                      />

                      <ViewTitle>Top View</ViewTitle>

                      <RideUnitTopPlan
                        location={location}
                        size={standType}
                        type={type}
                      />
                    </div>
                    <div>
                      {" "}
                      <ViewTitle> Side View</ViewTitle>
                      <SidePlan
                        location={location}
                        standType={standType}
                        type={type}
                      />
                    </div>
                  </PlansWrapper>
                )}
              </PlansWrapperAllViews>
              {isPDF && (
                <Dimensions>
                  All dimesnsion are in {isCM ? "CM" : "inches"}
                </Dimensions>
              )}
            </Wrap>
          );
        })}
    </>
  );
};

export default RidePlans;
const SideDetails = styled.div`
  @media ${device.mobileS} {
    width: 120px;
  }
  @media ${device.laptop} {
    width: 270px;
  }
`;

const unitSizes = {
  "large bicycle": `
top: -512px;
left: -380px;`,

  "large scooter": `
top: -430px;
left: -370px;`,

  "small bicycle": `
top: -512px;
left: -380px;`,

  "small scooter": `
top: -445px;
left: -303px;`,
};

const PDFRideImage = styled.img`
  margin-top: 20px;
  transform: scale(0.39);
  position: relative;
  ${(props) => unitSizes[props.type]}
`;

const Dimensions = styled.div`
  position: absolute;
  bottom: 127px;
  left: 97px;
`;
const ViewTitle = styled.div`
  text-align: left;
  margin: -21px 0px 20px 70px;
`;

const Flex = styled.div`
  display: flex;
  justify-content: start;
  @media ${device.mobileS} {
    font-size: 10px;
  }
  @media ${device.laptop} {
    font-size: 16px;
  }
`;

const Text = styled.div`
  @media ${device.mobileS} {
    width: 120px;
  }
  @media ${device.laptop} {
    width: 156px;
  }
`;

const Title = styled.div`
  font-weight: 800;
  @media ${device.mobileS} {
    font-size: 10px;
    margin-bottom: 4px;
  }
  @media ${device.laptop} {
    margin-bottom: 8px;
    font-size: 1em;
  }
`;

const Spec = styled(Title)`
  width: 100px;
`;
const UpperLine = styled.div`
  height: 0;
  @media ${device.mobileS} {
    width: 97px;
    margin-bottom: 17.3px;
    border-top: solid 1px #161616;
  }
  @media ${device.laptop} {
    width: 200px;
    margin-top: 20px;
    margin-bottom: 32px;
    border-top: solid 1px #161616;
  }
`;

const BottomLine = styled(UpperLine)`
  margin-bottom: 0px;
  @media ${device.mobileS} {
    margin-top: 17.3px;
  }
  @media ${device.laptop} {
    margin-top: 32px;
  }
`;

const Wrapper = styled.div`
  display: flex;

  @media ${device.mobileS} {
    padding-bottom: 140px;
  }

  @media ${device.laptop} {
    margin-bottom: 120px;
  }
`;
const PlansWrapperAllViews = styled.div`
  @media ${device.mobileS} {
    transform: scale(0.25);
    transform-origin: left top;
    margin: 0px 0px -640px 0px;
  }
  @media ${device.tablet} {
    transform: scale(1);
    margin: 0px;
  }
`;

const PlansWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: strech;
  justify-content: center;
  text-align: center;
`;

const PDFPage = styled.div`
  height: 1230px;
  width: 1920px;
  padding-top: 168px;
  position: relative;
`;

const ParaOne = styled.p`
  font-size: 52px;
  font-weight: bold;
  font-family: "Lexend", serif;
  margin: 0px;
  text-transform: uppercase;
  text-align: center;
  @media ${device.mobileS} {
    font-size: 20px;
  }
  @media ${device.laptop} {
    font-size: 2.4em;
  }
`;

const TextWrapper = styled.div`
  padding: 20px 0;
  flex-direction: column;
  display: flex;
  position: relative;
`;

const Pager = styled.div`
  position: absolute;
  bottom: 60px;
  right: 80px;
  font-size: 22px;
`;
